import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { buildLegacyStationConnectorPath, isValidObjectId } from './legacy-routing.util';

export const LegacyStationConnectorRedirect = () => {
    const { stationId, connectorId } = useParams();
    const { pathname, search, hash } = useLocation();

    if (!isValidObjectId(stationId) || !isValidObjectId(connectorId)) {
        return <Navigate to="/" replace />;
    }

    const prefix = `/${stationId}/${connectorId}`;
    const suffix = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : '';
    const normalizedSuffix = suffix.replace(/^\/setup-connector\/?$/, '');

    return (
        <Navigate
            to={buildLegacyStationConnectorPath(stationId!, connectorId!, search, hash).concat(
                normalizedSuffix
            )}
            replace
        />
    );
};
